import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../../App/Compositions/StepConfigurations";
import { Flow } from "../../Types/IFlow";

const noConfirmationNoBookFlowName = "NoConfirmationNoBookFlow";

/** The flow that a no-book guest should experience when booking without a confirmation step. */
class NoConfirmationNoBookFlow extends Flow {
  static readonly flowName = noConfirmationNoBookFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(
          noConfirmationNoBookFlowName,
          { ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationPreQualifiedPatientNavigatorConfiguration
        )
      : super(
          noConfirmationNoBookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationDefaultNavigatorConfiguration
        );
  }
}

export default NoConfirmationNoBookFlow;
